import { registerMFELoader, registerRemoteModule } from '@onviobr/mfe-loader';

registerMFELoader();

// Add any new Micro Front-End module here
registerRemoteModule(
	'@onviobr/staff-setup',
	() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "@onviobr/staff-setup" */'@onviobr/staff-setup')
);

registerRemoteModule(
	'@onvio/projects',
	() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "@onvio/projects" */'@onvio/projects')
);


registerRemoteModule(
	'@onviobr/dms-scan',
	() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "@onviobr/dms-scan" */'@onviobr/dms-scan')
);

registerRemoteModule(
	'@onvio/notification',
	() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "@onvio/notification" */'@onvio/notification')
);

registerRemoteModule(
	'@onvio/notification/open-notification',
	() =>
		import(
			/* webpackMode: "lazy" */ /* webpackChunkName: "@onvio/notification/open-notification" */
			'@onvio/notification/open-notification'
		),
);

registerRemoteModule(
	'@onviobr/banking-staff-dashboard',
	() =>
		import(
			/* webpackMode: "lazy" */ /* webpackChunkName: "@onviobr/banking-staff-dashboard" */
			'@onviobr/banking-staff-dashboard'
		),
);

registerRemoteModule(
	'@onviobr/dms-app',
	() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "@onviobr/dms-app" */'@onviobr/dms-app')
);

registerRemoteModule(
	'@onviobr/permissions-group',
	() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "@onviobr/permissions-group" */'@onviobr/permissions-group')
);

registerRemoteModule(
	'@onviobr/company-staff',
	() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "@onviobr/company-staff" */'@onviobr/company-staff')
);

registerRemoteModule('@onviobr/br-default-department',
	() =>
		import(
			/* webpackMode: "lazy" */ /* webpackChunkName: "@onviobr/br-default-department" */
			'@onviobr/br-default-department'
		),
);

registerRemoteModule('@onvio/new-notification',
	() =>
		import(
			/* webpackMode: "lazy" */ /* webpackChunkName: "@onvio/new-notification" */
			'@onvio/new-notification'
		)
);
